import React from 'react';
import { useParams } from 'react-router-dom';
import { StudyGuideBlock } from '@/pages/study-guide/study-guide-block';
import { learningPathEndpoints } from './block-endpoints';
import { PATHS } from '@/routes/paths';

export function LearningPathBlock() {
  const { trailId, chapterId, blockId } = useParams();
  return (
    <StudyGuideBlock
      endpoints={learningPathEndpoints(blockId)}
      backRoute={PATHS.LEARNING_PATH.CHAPTER(trailId, chapterId)}
      backLabel="Trilha"
    />
  );
}
